import appHomeDashboard from '@apps/home-dashboard/src/locales/en-AU.json';

const combined = {
  ...appHomeDashboard,
};

export default combined;
